import { Tracking } from '@panamax/app-state';
import { DidYouForgetTracingConstants } from '../did-you-forget-tracing.constants';

export const dyfApiCallTrace: Tracking = {
  tracing: {
    data: {
      traceContext: DidYouForgetTracingConstants.dyfApiCallEvent,
      isEndOfTrace: false,
      isStartOfTrace: true,
      attributes: {},
    },
  },
};
